module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lateral"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "lista-unidades"
  }, [_c('li', [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mudarSelecao('ccd-servicos')
      }
    }
  }, [_vm._v("Senha de Revogação")])]), _vm._v("\n      Altere a senha de revogação do certificado digital.\n    ")]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.mudarSelecao('ccd-servicos')
      }
    }
  }, [_vm._v("Revogar Certificado")])]), _vm._v("\n      Revogue aqui seu certificado digital utilizando a senha de revogação.\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/icon_more.png"),
      "width": "24",
      "height": "24",
      "alt": "Mais Produtos"
    }
  }), _vm._v("Mais procurados")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2647fcf4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuDireita.vue
// module id = 95
// module chunks = 0